import { useContext, useMemo, useRef, useState } from "react"
import { decryptData, encryptData } from "../../../utils/encrypt"
import { ToastContext } from "../../../context/ToastContext"

export const useCipher = () => {

    const {showInfo, showSuccess} = useContext(ToastContext);
    const tagRef = useRef(null);
    const [fieldValues, setFieldValues] = useState({decrypt: true, entered_text: "", generated_text: "", secret_key: process.env.REACT_APP_SECRET_KEY || "", iv: process.env.REACT_APP_IV || "", sk_view: "password", iv_view: "password"});
    const [loader, setLoader] = useState(false);

    const handleEcryptDecrypt = () => {
        if(!fieldValues?.entered_text?.trim()) {
            showInfo("Info", "Please enter text to encrypt/decrypt.");
            setFieldValues((prev) => ({...prev, generated_text: ""}));
            return;
        }
        const obj = {
            secret_key: fieldValues?.secret_key,
            iv: fieldValues?.iv
        }
        if(!fieldValues?.decrypt) {
            setFieldValues((prev) => ({...prev, generated_text: encryptData(fieldValues?.entered_text?.trim(), "", obj) || ""}));
        } else {
            let decrypted = decryptData(fieldValues?.entered_text?.trim(), "", obj);
            if(typeof decrypted === "object") {
                decrypted = JSON.stringify(decrypted, null, 2);
            }
            setFieldValues((prev) => ({...prev, generated_text: decrypted || ""}));
        }
    }

    const handleCopy = async (entered) => {
        try {
            if(entered ? fieldValues?.entered_text : fieldValues?.generated_text) {
                await navigator.clipboard.writeText(entered ? fieldValues?.entered_text : fieldValues?.generated_text);
                showSuccess("Success", "Text Copied!");
            }
        } catch (error) {
            console.error("Error copying in clipboard", error);
        }
    }

    return useMemo(() => ({
        tagRef, fieldValues, setFieldValues, handleEcryptDecrypt, handleCopy, loader
    }), [tagRef, fieldValues, setFieldValues, handleEcryptDecrypt, handleCopy, loader])
}